import axiosInstance from '@/api/axiosInstance';
import { CourseWithDetails } from '@/modules/learningCenter/types/course';
import { CreateCoursePayload } from './types';

/**
 * Create a new course
 * POST /api/learning-center/courses
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 * Returns the created course directly (not wrapped in { data: ... })
 */
export const createCourse = async (
  payload: CreateCoursePayload
): Promise<CourseWithDetails> => {
  try {
    const response = await axiosInstance.post<CourseWithDetails>(
      '/api/learning-center/courses',
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error creating course:', error);
    throw error;
  }
};
